export default {
  title: 'Datei hinzufügen: {{slot}}',
  replace_title: 'Datei ersetzen: {{slot}}',
  replace_description: 'Die neue Datei tritt an die Stelle dieser. Die alte bewahren wir in unseren Unterlagen auf.',
  form: {
    kind: {
      label: 'Art des Ausweises',
      options: {
        passport: 'Reisepass',
        driver_license: 'Führerschein',
        id_card: 'Personalausweis',
        residence_permit: 'Aufenthaltstitel',
      },
    },
    front: {
      label: 'Vorderseite',
    },
    back: {
      label: 'Rückseite',
    },
    file: {
      label: 'Datei',
    },
    expires_at: {
      label: 'Gültig bis',
      placeholder: 'Datum auswählen',
    },
    holder: {
      label: 'Wessen Ausweis ist das?',
      options: {
        owner: 'Meiner, der des Inhabers',
        partner: 'Der eines Gesellschafters',
      },
    },
    holder_name: {
      label: 'Name des Gesellschafters',
      placeholder: 'Vor- und Nachname',
    },
  },
  accepted_files: 'PDF, JPG oder PNG, bis {{max}} MB.',
  accepted_images_min: 'Ein Foto muss mindestens {{min}} KB groß sein.',
  errors: {
    file_type: 'Nur PDF-, JPG- oder PNG-Dateien werden akzeptiert.',
    file_too_large: 'Die Datei ist größer als {{max}} MB.',
    file_too_small: 'Ein Foto muss mindestens {{min}} KB groß sein.',
  },
  buttons: {
    select_file: 'Datei auswählen',
    submit: 'Hochladen',
    cancel: 'Abbrechen',
  },
  toasts: {
    success: 'Datei hochgeladen',
    error: 'Die Datei konnte nicht hochgeladen werden.',
  },
};
